
export class Frequencia {
	id: number;
	justificativa: string;
	dataFrequencia: Date;
	presenca?: Boolean;
	ausencia?: boolean;
	usuarioAlteracao: number;

	desabilitado: Boolean;
}